import { ProdKindEnum } from '@src/helper/enum/prod-kind-enum';
import React from 'react';
import { loadReactLazyCharts } from '@src/components/react-echarts-lazy';
import { LazyElement, routerConfigManager } from '../helper/factory';

/**
 *
 * 1、对react 项目路由作统一管理
 * 2、使用typescript对路由参数作校验， 方便团队协作，方便项目后期维护
 *
 * createRoute 参数参考 react router v6 route
 * @see https://reactrouter.com/docs/en/v6/api#router
 *
 * 最终生成路由配置对象 使用 useroutes 生成路由
 * @see https://reactrouter.com/docs/en/v6/api#useroutes
 */

// 持仓首页
export const PositionRoute = routerConfigManager.createRoute({
  path: 'position',
  element: <LazyElement load={() => import('@src/page/lc-position')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});
export type ColumnListRouteParams = {
  id: string;
  columnId: string;
  columnTitle: string;
  tabId?: string;
  sourceFrom?: string;
  tabName?: string;
};
// 栏目列表
export const ColumnListPageRoute = routerConfigManager.createRoute<ColumnListRouteParams>({
  path: 'columnList',
  element: <LazyElement load={() => import('@src/page/fund-area-template/column-list')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});
export type GuessThinkDetailRouteParams = {
  /** 是否持仓 */
  isHeld: boolean;
  prevPageName: string;
};
// 猜你所想详情
export const GuessThinkDetailPageRoute = routerConfigManager.createRoute<GuessThinkDetailRouteParams>({
  path: 'guessThink',
  element: <LazyElement load={() => import('@src/page/lc-position/guess-think-detail')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 基金持仓
export const FundPositionRoute = routerConfigManager.createRoute({
  path: 'fundPosition',
  element: <LazyElement load={() => import('@src/page/fund-position')} />,
});

// 高端持仓
export const HighPositionRoute = routerConfigManager.createRoute({
  path: 'highPosition',
  element: <LazyElement load={() => import('@src/page/high-position')} />,
});

// 高端持仓
export const RegularPositionRoute = routerConfigManager.createRoute({
  path: 'regularPosition',
  element: <LazyElement load={() => import('@src/page/regular-position')} />,
});

export type PositionDetailRouteParams = {
  /** 产品TA */
  prodtaNo: string;
  /** 产品代码 */
  productCode: string;
  /** 市值 */
  marketValue: string;
};
export type FundPositionDetailRouteParams = {
  /** 最新收益 */
  latestEarnings: string;
  /** 持有收益 */
  holdingIncome: number;
  /** 产品代码类型 */
  prodCodeType: string;
} & PositionDetailRouteParams;
// 基金持仓详情
export const FundPositionDetailRoute = routerConfigManager.createRoute<FundPositionDetailRouteParams>({
  path: 'fundPositionDetail',
  element: <LazyElement load={() => import('@src/page/fund-position-detail')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
  beforeNavigate() {
    loadReactLazyCharts();
  },
});

export type HighPositionDetailRouteParams = {
  /** 最新净值日期 */
  navDate: string;
  /** 持有收益 */
  holdingIncome: number;
} & PositionDetailRouteParams;
// 高端持仓详情
export const HighPositionDetailRoute = routerConfigManager.createRoute<HighPositionDetailRouteParams>({
  path: 'highPositionDetail',
  element: <LazyElement load={() => import('@src/page/high-position-detail')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
  beforeNavigate() {
    loadReactLazyCharts();
  },
});

// 高端订阅
export const HighNotificationSubscriptionRoute = routerConfigManager.createRoute({
  path: 'highNotificationSubscription',
  element: <LazyElement load={() => import('@src/page/high-end-finance/notification-subscription/index')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type RegularPositionDetailRouteParams = {
  /** 预计到期收益 */
  predictIncome: number;
  /** 成交编号 */
  businessId?: string;
  entrustDate?: string;
  prodEndDate?: string;
} & PositionDetailRouteParams;
// 定期持仓详情-收益凭证;
export const RegularPositionDetailScripRoute = routerConfigManager.createRoute<RegularPositionDetailRouteParams>({
  path: 'regularPositionDetailScrip',
  element: <LazyElement load={() => import('@src/page/regular-position-detail-scrip')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 定期持仓详情-报价回购
export const RegularPositionDetailRepoRoute = routerConfigManager.createRoute<RegularPositionDetailRouteParams>({
  path: 'regularPositionDetailRepo',
  element: <LazyElement load={() => import('@src/page/regular-position-detail-repo')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 定投计划
export const AutoInvestmentPlanRoute = routerConfigManager.createRoute({
  path: 'autoInvestmentPlan',
  element: <LazyElement load={() => import('@src/page/auto-investment-plan')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type MyAutoInvestmentRouteParams = {
  /** 产品代码 */
  prodCode: string;
};

// 我的定投
export const MyAutoInvestmentRoute = routerConfigManager.createRoute<MyAutoInvestmentRouteParams>({
  path: 'myAutoInvestment',
  element: <LazyElement load={() => import('@src/page/my-auto-investment')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type AutoInvestmentDetailRouteParams = {
  /** 定投编号 */
  allotno: string;
  /** 产品代码 */
  prodCode: string;
};

// 定投详情
export const AutoInvestmentDetailRoute = routerConfigManager.createRoute<AutoInvestmentDetailRouteParams>({
  path: 'autoInvestmentDetail',
  element: <LazyElement load={() => import('@src/page/auto-investment-detail')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type SingleProductIncomeDetailRouteParams = {
  prodtaNo: string;
  productCode: string;
  prodName: string;
  incomeBalance: string | number;
  type?: string;
};
// 单产品收益明细
export const SingleProductIncomeDetailRoute = routerConfigManager.createRoute<SingleProductIncomeDetailRouteParams>({
  path: 'singleProductIncomeDetail',
  element: <LazyElement load={() => import('@src/page/single-product-income-detail')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 所有产品收益明细
export const AllProductIncomeDetailRoute = routerConfigManager.createRoute({
  path: 'allProductIncomeDetail',
  element: <LazyElement load={() => import('@src/page/all-product-income-detail')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type SingleTransactionRecordRouteParams = {
  prodCode: string;
  prodName: string;
};
// 单产品交易记录
export const SingleTransactionRecordRoute = routerConfigManager.createRoute<SingleTransactionRecordRouteParams>({
  path: 'singleTransactionRecord',
  element: <LazyElement load={() => import('@src/page/single-transaction-record')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type AllTransactionRecordRouteParams = {
  prodType?: ProdKindEnum;
};
// 所有产品交易记录
export const AllTransactionRecordRoute = routerConfigManager.createRoute<AllTransactionRecordRouteParams>({
  path: 'allTransactionRecord',
  element: <LazyElement load={() => import('@src/page/all-transaction-record')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 公募基金-申购记录
export const MutualPurchaseRecordRoute = routerConfigManager.createRoute({
  path: 'mutualPurchaseRecord',
  element: <LazyElement load={() => import('@src/page/trade-record/mutual-purchase-record')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 公募基金-定投记录
export const MutualAutoInvestmentRecordRoute = routerConfigManager.createRoute({
  path: 'mutualAutoInvestmentRecord',
  element: <LazyElement load={() => import('@src/page/trade-record/mutual-auto-investment-record')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 公募基金-赎回记录
export const MutualRedemptionRecordRoute = routerConfigManager.createRoute({
  path: 'mutualRedemptionRecord',
  element: <LazyElement load={() => import('@src/page/trade-record/mutual-redemption-record')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 公募基金-认购记录
export const MutualSubscriptionRecordRoute = routerConfigManager.createRoute({
  path: 'mutualSubscriptionRecord',
  element: <LazyElement load={() => import('@src/page/trade-record/mutual-subscription-record')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 报价回购-购买记录
export const RegularRepoBuyRecordRoute = routerConfigManager.createRoute({
  path: 'regularRepoBuyRecord',
  element: <LazyElement load={() => import('@src/page/trade-record/regular-repo-buy-record')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 报价回购-购回记录
export const RegularRepoBackRecordRoute = routerConfigManager.createRoute({
  path: 'regularRepoBackRecord',
  element: <LazyElement load={() => import('@src/page/trade-record/regular-repo-back-record')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 报价回购-交易完成记录
export const RegularRepoSuccessRecordRoute = routerConfigManager.createRoute({
  path: 'regularRepoSuccessRecord',
  element: <LazyElement load={() => import('@src/page/trade-record/regular-repo-success-record')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 报价回购-交易失败记录
export const RegularRepoFailRecordRoute = routerConfigManager.createRoute({
  path: 'regularRepoFailRecord',
  element: <LazyElement load={() => import('@src/page/trade-record/regular-repo-fail-record')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 收益凭证交易记录
export const RegularScripRecordRoute = routerConfigManager.createRoute({
  path: 'regularScripRecord',
  element: <LazyElement load={() => import('@src/page/trade-record/regular-scrip-record')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 预约赎回记录
export const ReserveRedemptionRecordRoute = routerConfigManager.createRoute({
  path: 'reserveRedemptionRecord',
  element: <LazyElement load={() => import('@src/page/trade-record/reserve-redemption-record')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 高端交易记录
export const HighTradeRecordRoute = routerConfigManager.createRoute({
  path: 'highTradeRecord',
  element: <LazyElement load={() => import('@src/page/trade-record/high-trade-record')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 信托购买记录
export const TrustBuyRecordRoute = routerConfigManager.createRoute({
  path: 'trustBuyRecord',
  element: <LazyElement load={() => import('@src/page/trade-record/trust-buy-record')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 转换交易记录
export const ExchangeRecordRoute = routerConfigManager.createRoute({
  path: 'exchangeRecord',
  element: <LazyElement load={() => import('@src/page/trade-record/exchange-record')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 其他交易记录
export const OtherRecordRoute = routerConfigManager.createRoute({
  path: 'otherRecord',
  element: <LazyElement load={() => import('@src/page/trade-record/other-record')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 基金产品详情页代码入参
export type FundDetailCodeRouteParams = {
  fundCode: string;
  orderNo?: string;
  useTTDSdk?: 'Y' | 'N';
  fixedFundCode?: 'Y' | 'N';
  err646?: boolean;
  err5210?: boolean;
  err5211?: boolean;
} & { fromPosition?: boolean };

// 统一基金产品详情页入口
export const ProductDetailRoute = routerConfigManager.createRoute<FundDetailCodeRouteParams>({
  path: 'productDetail',
  element: <LazyElement load={() => import('@src/page/product-detail')} />,
  beforeNavigate() {
    loadReactLazyCharts();
  },
});

// 基金产品详情页
export const FundProductDetailRoute = routerConfigManager.createRoute<FundDetailCodeRouteParams>({
  path: 'fundProductDetail',
  element: <LazyElement load={() => import('@src/page/fund-product-detail')} />,
  beforeNavigate() {
    loadReactLazyCharts();
  },
});

export type FundProductFullChartsRouteParams = {
  fundCode: string;
  fundName?: string;
};

// 基金详情-横屏图表
export const FundProductFullChartsRoute = routerConfigManager.createRoute<FundProductFullChartsRouteParams>({
  path: 'fundProductFullCharts',
  element: <LazyElement load={() => import('@src/page/fund-product-detail/fund-product-full-charts')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
  beforeNavigate() {
    loadReactLazyCharts();
  },
});

// 基金档案
export type FundInfoRouteParams = {
  fundCode: string;
};

export const FundInfoRoute = routerConfigManager.createRoute<FundInfoRouteParams>({
  path: 'fundInfo/:fundCode',
  element: <LazyElement load={() => import('@src/page/fund-news/fund-info')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 基金档案-基金概况
export const FundOverviewRoute = FundInfoRoute.createRoute({
  path: 'overview',
  element: <LazyElement load={() => import('@src/page/fund-news/fund-info/fund-overview')} />,
});

export type FundManagerRouteParams = {
  managerId?: string;
};

// 基金档案-基金经理
export const FundManagerRoute = FundInfoRoute.createRoute<FundManagerRouteParams>({
  path: 'manager',
  element: <LazyElement load={() => import('@src/page/fund-news/fund-info/fund-manager')} />,
});

// 基金档案-基金公司
export const FundCompanyRoute = FundInfoRoute.createRoute({
  path: 'company',
  element: <LazyElement load={() => import('@src/page/fund-news/fund-info/fund-company')} />,
});

// 基金档案-持仓
export const FundInfoPositionRoute = FundInfoRoute.createRoute({
  path: 'position',
  element: <LazyElement load={() => import('@src/page/fund-news/fund-info/fund-info-position')} />,
});

// 基金档案-基金分红
export const FundDividendsRoute = FundInfoRoute.createRoute({
  path: 'dividends',
  element: <LazyElement load={() => import('@src/page/fund-news/fund-info/fund-dividends')} />,
});

// 基金档案-基金公告
export const FundAnnouncementRoute = FundInfoRoute.createRoute({
  path: 'announcement',
  element: <LazyElement load={() => import('@src/page/fund-news/fund-info/fund-announcement')} />,
});

// 基金档案-基金公告-不含Tab
export const FundInfoAnnouncementRoute = routerConfigManager.createRoute<FundInfoRouteParams>({
  path: 'fundInfoAnnouncement/:fundCode',
  element: <LazyElement load={() => import('@src/page/fund-news/fund-info/fund-info-announcement')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type HighFundAnnouncementRouteParams = {
  /** 基金公司id */
  fundCode: string;
  fundName: string;
  productTypeName: string;
};

// 高端理财-基金公告
export const HighFundAnnouncementRoute = routerConfigManager.createRoute<HighFundAnnouncementRouteParams>({
  path: 'highFundAnnouncement',
  element: <LazyElement load={() => import('@src/page/high-end-finance/high-fund-announcement')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});
// 历史净值页代码入参
export type HighFundHistoryNetRouteParams = {
  fundCode: string;
};
// 高端理财-历史净值
export const HighFundHistoryNetRoute = routerConfigManager.createRoute<HighFundHistoryNetRouteParams>({
  path: 'highFundHistoryNet',
  element: <LazyElement load={() => import('@src/page/high-end-finance/high-fund-history-net')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type CompanyFundListRouteParams = {
  /** 基金公司id */
  iaCode: string;
  companyName: string;
};

// 旗下基金
export const CompanyFundListRoute = routerConfigManager.createRoute<CompanyFundListRouteParams>({
  path: 'companyFundList',
  element: <LazyElement load={() => import('@src/page/fund-news/company-fund-list')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 规模风向标
export const scaleTrendAreaRoute = routerConfigManager.createRoute({
  path: 'scaleTrendArea',
  element: <LazyElement load={() => import('@src/page/fund-index/scale-trend-area/index')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type HotTopicsAreaRouteParams = {
  topicId: number;
};
// 热点话题
export const HotTopicsAreaRoute = routerConfigManager.createRoute<HotTopicsAreaRouteParams>({
  path: 'hotTopicsArea',
  element: <LazyElement load={() => import('@src/page/fund-index/hot-topics-area/index')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 机会清单
export const OpportunityListRoute = routerConfigManager.createRoute({
  path: 'opportunityList',
  element: <LazyElement load={() => import('@src/page/fund-index/opportunity-list/index')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type QuoteRepurchaseListRouteParams = {
  title: string;
};
// 报价回购列表
export const QuoteRepurchaseListRoute = routerConfigManager.createRoute<QuoteRepurchaseListRouteParams>({
  path: 'quoteRepurchaseList',
  element: <LazyElement load={() => import('@src/page/fund-index/quote-repurchase-list/index')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type FundHistoryMarketValueRouteParams = {
  fundCode: string;
};

// 历史净值
export const FundHistoryMarketValueRoute = routerConfigManager.createRoute<FundHistoryMarketValueRouteParams>({
  path: 'historyMarketValue',
  element: <LazyElement load={() => import('@src/page/fund-news/fund-history-market-value')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 货币基金产品详情页
export const MonetaryFundProductDetailRoute = routerConfigManager.createRoute<FundDetailCodeRouteParams>({
  path: 'monetaryFundProductDetail',
  element: <LazyElement load={() => import('@src/page/monetary-fund-product-detail')} />,
});

// 新发基金详情页
export const NewFundProductDetailRoute = routerConfigManager.createRoute<FundDetailCodeRouteParams>({
  path: 'newFundProductDetail',
  element: <LazyElement load={() => import('@src/page/new-fund-product-detail')} />,
});

export type PdfViewerRouteParams = {
  url: string;
  title?: string;
};

// pdf预览页
export const PdfViewerRoute = routerConfigManager.createRoute<PdfViewerRouteParams>({
  path: 'pdf',
  element: <LazyElement load={() => import('@src/page/pdf-viewer')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type FundTradeRuleRouteParams = {
  fundCode: string;
  tab?: 'buy' | 'sell';
};

// 基金交易规则页面
export const FundTradeRuleRoute = routerConfigManager.createRoute<FundTradeRuleRouteParams>({
  path: 'fundTradeRule',
  element: <LazyElement load={() => import('@src/page/fund-news/fund-trade-rule')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 阶段涨幅列表
export const RiseListPageRoute = routerConfigManager.createRoute<FundDetailCodeRouteParams>({
  path: 'riseListPage',
  element: <LazyElement load={() => import('@src/page/monetary-fund-product-detail/rise-list-page')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 历史七日年化
export const AnnualizationListPageRoute = routerConfigManager.createRoute<FundDetailCodeRouteParams>({
  path: 'annualizationListPage',
  element: <LazyElement load={() => import('@src/page/monetary-fund-product-detail/annualization-list-page')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 历史净值
export const NetWorthRiseListPageRoute = routerConfigManager.createRoute<FundDetailCodeRouteParams>({
  path: 'netWorthRiseListPage',
  element: <LazyElement load={() => import('@src/page/fund-product-detail/net-worth-list-page')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});
// 高端-历史净值
export const HighNetWorthRiseListPageRoute = routerConfigManager.createRoute<FundDetailCodeRouteParams>({
  path: 'highNetWorthRiseListPage',
  element: <LazyElement load={() => import('@src/page/high-end-finance/high-fund-history-net')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 定投收益
export const InvestmentProfitListPagePageRoute = routerConfigManager.createRoute<FundDetailCodeRouteParams>({
  path: 'investmentProfitListPage',
  element: <LazyElement load={() => import('@src/page/fund-product-detail/investment-profit-list-page')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type SignListRouteParams = {
  prodCode: string;
  handlerName?: string | undefined;
  destroyPageNo?: string;
};

// 资管协议签署列表
export const ReadListRoute = routerConfigManager.createRoute<SignListRouteParams>({
  path: 'readList',
  element: <LazyElement load={() => import('@src/page/high-end-finance/asset-management/read-list/index')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 资管协议签署列表
export const SignListRoute = routerConfigManager.createRoute<SignListRouteParams>({
  path: 'signList',
  element: <LazyElement load={() => import('@src/page/high-end-finance/asset-management/sign-list/index')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type SignBoxRouteParams = {
  contractId?: string;
  prodCode?: string;
};
// 资管协议签名框
export const SignBoxRoute = routerConfigManager.createRoute<SignBoxRouteParams>({
  path: 'signBox',
  element: <LazyElement load={() => import('@src/page/high-end-finance/asset-management/sign-box')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type PdfViewerSignRouteParams = {
  url?: string;
  title?: string;
  signBtns?: boolean;
  agreeBtn?: boolean;
  fileType?: number;
  contractId?: string;
  onlyRead?: boolean;
  destroyPageNo?: string;
  pageNo?: number;
  isSigned?: boolean;
  clientId?: number;
  prodCode?: string;
  fileIndex?: number;
  hasSigned?: boolean;
};

// pdf预览签署
export const PdfViewerSignRoute = routerConfigManager.createRoute<PdfViewerSignRouteParams>({
  path: 'pdfSign',
  element: <LazyElement load={() => import('@src/page/high-end-finance/components/pdf-viewer-sign')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 资管产品详情页
export const AssetManagementProductDetailRoute = routerConfigManager.createRoute<FundDetailCodeRouteParams>({
  path: 'assetManagementProductDetail',
  element: <LazyElement load={() => import('@src/page/high-end-finance/asset-management')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});

// 私募产品详情页
export const PrivateEquityProductDetailRoute = routerConfigManager.createRoute<FundDetailCodeRouteParams>({
  path: 'privateEquityProductDetail',
  element: <LazyElement load={() => import('@src/page/high-end-finance/private-equity')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});
// 私募产品详情页
export const PrivateEquityProductTuoTuoDiDetailRoute = routerConfigManager.createRoute<FundDetailCodeRouteParams>({
  path: 'privateEquityProductTuoTuoDiDetail',
  element: <LazyElement load={() => import('@src/page/high-end-finance/private-equity-tuotuodi')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});

// 资管协议签署列表
export const privateEquityReadListRoute = routerConfigManager.createRoute<SignListRouteParams & { orderNo: string }>({
  path: 'privateEquityReadList',
  element: <LazyElement load={() => import('@src/page/high-end-finance/private-equity/read-list/index')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});
// 代销机构风险揭示书签署情页
export const RiskDisclosureSignRoute = routerConfigManager.createRoute<FundDetailCodeRouteParams>({
  path: 'riskDisclosureSign',
  element: <LazyElement load={() => import('@src/page/high-end-finance/private-equity/risk-disclosure-sign')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});

export type AdvertImageRouteParams = {
  id: number;
  fundCode: string;
  pageType: string;
  showAppNav?: boolean;
};
// 广告页
export const AdvertImageRoute = routerConfigManager.createRoute<AdvertImageRouteParams>({
  path: 'advertImage',
  element: <LazyElement load={() => import('@src/page/advert-image')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});
// 热销基金。
export const HotFundDetailRoute = routerConfigManager.createRoute({
  path: 'hotFundDetail',
  element: <LazyElement load={() => import('@src/page/hot-fund-detail')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 基金超市
export const FundMarketPageRoute = routerConfigManager.createRoute({
  path: 'fundMarket',
  element: <LazyElement load={() => import('@src/page/fund-market')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 资管专区
export const AssetManagementZoneRoute = routerConfigManager.createRoute({
  path: 'assetManagementZone',
  element: <LazyElement load={() => import('@src/page/asset-management-zone')} />,
});

// 理财首页
export const FundIndexPageRoute = routerConfigManager.createRoute({
  path: 'fundIndex',
  element: <LazyElement load={() => import('@src/page/fund-index')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 理财工具箱
export const MenuToolBoxPageRoute = routerConfigManager.createRoute({
  path: 'menuToolBox',
  element: <LazyElement load={() => import('@src/page//fund-index/menu-tool-box')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 兴银基金专区
export const XingYinFundAreaPageRoute = routerConfigManager.createRoute({
  path: 'xingYinFundArea',
  element: <LazyElement load={() => import('@src/page//fund-index/xing-yin-fund-area')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 兴银基金人气推荐页面
export const XingYinRecommendDetailPageRoute = routerConfigManager.createRoute({
  path: 'xingYinRecommend',
  element: <LazyElement load={() => import('@src/page//fund-index/xing-yin-recommend-detail')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type CF100DetailPageRouteParams = {
  columnName: string;
  columnDesc?: string;
  tabIndex?: string;
};

// 华财100详情
export const CF100DetailPageRoute = routerConfigManager.createRoute<CF100DetailPageRouteParams>({
  path: 'cf100',
  element: <LazyElement load={() => import('@src/page//fund-index/cf-100-detail')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type ThreeDirectionsDetailPageRoutePrams = {
  title: string;
  tabId: string;
};

// 三大方向详情
export const ThreeDirectionsDetailPageRoute = routerConfigManager.createRoute<ThreeDirectionsDetailPageRoutePrams>({
  path: 'threeDirections',
  element: <LazyElement load={() => import('@src/page/fund-index/three-directions-detail')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 定投专区
export const FixedInvestmentAreaPageRoute = routerConfigManager.createRoute({
  path: 'fixedInvestmentArea',
  element: <LazyElement load={() => import('@src/page/fund-index/fixed-investment-area')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type FundAreaPageRouteParams = {
  id: number;
  tickerTitle?: string;
  tickerAbstract?: string;
  shareLinkUrl?: string;
  shareBannerUrl?: string;
};
// 理财专区
export const FundAreaTemplatePageRoute = routerConfigManager.createRoute<FundAreaPageRouteParams>({
  path: 'fundAreaTemplate',
  element: <LazyElement load={() => import('@src/page/fund-area-template')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});
export type LcClassRoomListPageParams = {
  type: number;
  templateId: string;
};
// 理财专区
export const LcClassRoomPageRoute = routerConfigManager.createRoute<LcClassRoomListPageParams>({
  path: 'lcClassRoomList',
  element: <LazyElement load={() => import('@src/page/fund-area-template/lc-classroom')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type LcClassRoomDetailPageParams = {
  infoBigType: string;
  infoID: string;
};
// 理财专区
export const LcClassRoomDetailPageRoute = routerConfigManager.createRoute<LcClassRoomDetailPageParams>({
  path: 'lcClassRoomDetail',
  element: <LazyElement load={() => import('@src/page/fund-area-template/lc-classroom/detail')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type FixedInvestmentListPageRouteParams = {
  id: number;
  title: string;
};

// 定投专区列表详情页
export const FixedInvestmentListPageRoute = routerConfigManager.createRoute<FixedInvestmentListPageRouteParams>({
  path: 'fixedInvestmenList',
  element: <LazyElement load={() => import('@src/page/fund-index/fixed-investment-list')} />,
});

// 活期理财列表页
export const MonetaryFundListPageRoute = routerConfigManager.createRoute({
  path: 'monetaryFundList',
  element: <LazyElement load={() => import('@src/page/monetary-fund-list')} />,
});

export type FundManagerDetailPageRouteParams = {
  personalCode: string;
} & FundInfoRouteParams;

// 基金经理详情
export const FundManagerDetailPageRoute = routerConfigManager.createRoute<FundManagerDetailPageRouteParams>({
  path: 'fundManagerDetail',
  element: <LazyElement load={() => import('@src/page//fund-index/fund-manager-detail')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type DeepReportDetailPageRouteParams = {
  id: string;
};

// 深度报告详情
export const DeepReportDetailPageRoute = routerConfigManager.createRoute<DeepReportDetailPageRouteParams>({
  path: 'deepReportDetail',
  element: <LazyElement load={() => import('@src/page//fund-index/fund-manager-detail/deep-report-detail')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type HighFundManagerDetailPageRouteParams = {
  personalName: string;
} & FundInfoRouteParams;

// 高端基金经理详情
export const HighFundManagerDetailPageRoute = routerConfigManager.createRoute<HighFundManagerDetailPageRouteParams>({
  path: 'highFundManagerDetail',
  element: <LazyElement load={() => import('@src/page/fund-index/high-fund-manager-detail')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 自助回访
export type ReturnVisitRouteParams = {
  fromSource?: string;
};
export const ReturnVisitRoute = routerConfigManager.createRoute<ReturnVisitRouteParams>({
  path: 'returnVisit',
  element: <LazyElement load={() => import('@src/page/return-visit')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});

export type QuoteRepurchaseDetailPageRouteParams = {
  stockCode: string;
};

// 报价回购详情页
export const QuoteRepurchaseDetailPageRoute = routerConfigManager.createRoute<QuoteRepurchaseDetailPageRouteParams>({
  path: 'quoteRepurchaseDetail',
  element: <LazyElement load={() => import('@src/page/quote-repurchase-detail')} />,
});

// 报价回购 收益计算
export const QuoteRepurchaseIncodeCalcPageRoute = routerConfigManager.createRoute<QuoteRepurchaseDetailPageRouteParams>(
  {
    path: 'incomeCalc',
    element: <LazyElement load={() => import('@src/page/quote-repurchase-detail/income-calc')} />,
    webviewConfig: {
      statusBarDark: 1,
    },
  }
);

export type HighEndFinanceRouteParams = {
  tabIndex?: string;
};

// 高端理财首页
export const HighEndFinanceRoute = routerConfigManager.createRoute<HighEndFinanceRouteParams>({
  path: 'highEndFinance',
  element: <LazyElement load={() => import('@src/page/high-end-finance')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});

// 高端理财全部产品
export const HighEndFinanceAllProductsRoute = routerConfigManager.createRoute({
  path: 'highEndFinanceAllProducts',
  element: <LazyElement load={() => import('@src/page/high-end-finance/allProducts')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});

// 高端理财合格认证
export const HighEndFinanceConformityCertificationRoute = routerConfigManager.createRoute({
  path: 'highEndFinanceConformityCertification',
  element: <LazyElement load={() => import('@src/page/high-end-finance/conformity-certification')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});

export type InformationRouteParams = {
  type: string;
};

// 理财资讯
export const InformationRoute = routerConfigManager.createRoute<InformationRouteParams>({
  path: 'information',
  element: <LazyElement load={() => import('@src/page/information')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});

// 高端理财资讯
export const HighEndFinanceInformationRoute = routerConfigManager.createRoute({
  path: 'highEndFinanceInformation',
  element: <LazyElement load={() => import('@src/page/high-end-finance/financial-information')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});

export type InformationDetailRouteParams = {
  type: string;
  infoID: string;
};

// 理财资讯详情
export const InformationDetailRoute = routerConfigManager.createRoute<InformationDetailRouteParams>({
  path: 'informationDetail',
  element: <LazyElement load={() => import('@src/page/information/detail')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});

// 高端理财-理财日历
export const HighEndFinanceFinancialCalendarRoute = routerConfigManager.createRoute({
  path: 'highEndFinanceFinancialCalendar',
  element: <LazyElement load={() => import('@src/page/high-end-finance/financial-calendar')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});

export type ProductOpenCalendarRouteParams = {
  fundCode?: string;
};

// 高端理财-理财日历
export const ProductOpenCalendarRoute = routerConfigManager.createRoute<ProductOpenCalendarRouteParams>({
  path: 'productOpenCalendar',
  element: <LazyElement load={() => import('@src/page/high-end-finance/product-open-calendar')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});

export type RegularScripDetailRouteParams = {
  prodCode: string;
};

// 收益凭证详情
export const RegularScripDetailRoute = routerConfigManager.createRoute<RegularScripDetailRouteParams>({
  path: 'regularScripDetail',
  element: <LazyElement load={() => import('@src/page/regular-scrip/regular-scrip-detail')} />,
});

export type RegularScripBuyRouteParams = RegularScripDetailRouteParams & { prodName: string };

// 收益凭证购买页
export const RegularScripBuyRoute = routerConfigManager.createRoute<RegularScripBuyRouteParams>({
  path: 'refularScripBuy',
  element: <LazyElement load={() => import('@src/page/regular-scrip/regular-scrip-buy')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type RegularScripSignProtocolRouteParams = {
  contractId: string;
  filePath: string;
  fileName: string;
};

// 收益凭证协议签署页
export const RegularScripSignProtocolRoute = routerConfigManager.createRoute<RegularScripSignProtocolRouteParams>({
  path: 'regularScripSign',
  element: <LazyElement load={() => import('@src/page/regular-scrip/sign-protocol')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type RegularScripSignProtocolListRouteParams = {
  prodCode: string;
  sessionId: string;
};

// 收益凭证协议列表页
export const RegularScripSignProtocolListRoute =
  routerConfigManager.createRoute<RegularScripSignProtocolListRouteParams>({
    path: 'regularScripSignList',
    element: <LazyElement load={() => import('@src/page/regular-scrip/sign-protocol-list')} />,
    webviewConfig: {
      statusBarDark: 1,
    },
  });

export type RegularScripResultRouteParams = {
  prodCode: string;
  prodName: string;
  money: string;
};

// 收益凭证结果页
export const RegularScripResultRoute = routerConfigManager.createRoute<RegularScripResultRouteParams>({
  path: 'regularScripResult',
  element: <LazyElement load={() => import('@src/page/regular-scrip/regular-scrip-result')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 高端理财-投资策略
export const InvestmentStrategyDetailRoute = routerConfigManager.createRoute({
  path: 'investmentStrategyDetail',
  element: <LazyElement load={() => import('@src/page/high-end-finance/investment-strategy-detail')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 高端理财-历史规模列表页
export const HistoricalScaleDetailRoute = routerConfigManager.createRoute({
  path: 'historicalScaleDetail',
  element: <LazyElement load={() => import('@src/page/high-end-finance/historical-scale-detail')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type ImageViewerwRouteParams = {
  img: string;
  title: string;
};

// 图片预览页
export const ImageViewerwRoute = routerConfigManager.createRoute<ImageViewerwRouteParams>({
  path: 'imgViewer',
  element: <LazyElement load={() => import('@src/page/image-viewer')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 定期持仓-收益凭证列表
export const ContractsProdListRoute = routerConfigManager.createRoute({
  path: 'contractsProdList',
  element: <LazyElement load={() => import('@src/page/regular-position/contracts-prod-list')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type ContractsListRouteParams = {
  prodCode: string;
};

// 定期持仓-收益凭证电子合同列表
export const ContractsListRoute = routerConfigManager.createRoute<ContractsListRouteParams>({
  path: 'contractsList',
  element: <LazyElement load={() => import('@src/page/regular-position/contract-list')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 私募美市产品详情页
export const PrivateEquityProductDetailMeishiRoute = routerConfigManager.createRoute<FundDetailCodeRouteParams>({
  path: 'privateEquityProductDetailMeishi',
  element: <LazyElement load={() => import('@src/page/high-end-finance/private-equity-meishi')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});

export type CollectiveTrustRouteParams = {
  prodCode: string;
};
// 信托购买页
export const TrustBuyPageRoute = routerConfigManager.createRoute<CollectiveTrustRouteParams>({
  path: 'trustBuy',
  element: <LazyElement load={() => import('@src/page/high-end-finance/collective-trust/trust-buy')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});

export type TrustReadListRouteParams = {
  prodCode: string;
  handlerName?: string | undefined;
  // prodName: string;
  // destroyPageNo?: string;
};

// 信托协议签署列表
export const TrustReadListRoute = routerConfigManager.createRoute<TrustReadListRouteParams>({
  path: 'trustReadList',
  element: <LazyElement load={() => import('@src/page/high-end-finance/collective-trust/trust-read-list')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});
export type TrustSignListRouteParams = {
  prodCode: string;
  // prodName: string;
  destroyPageNo?: string;
};
// 信托协议签署列表
export const TrustSignListRoute = routerConfigManager.createRoute<TrustSignListRouteParams>({
  path: 'trustSignList',
  element: <LazyElement load={() => import('@src/page/high-end-finance/collective-trust/trust-sign-list')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});

// 信托详情页
export const CollectiveTrustDetailRoute = routerConfigManager.createRoute<CollectiveTrustRouteParams>({
  path: 'collectiveTrustDetail',
  element: <LazyElement load={() => import('@src/page/high-end-finance/collective-trust')} />,
  webviewConfig: {
    statusBarDark: 0,
  },
});

// 信托历史净值页面
export const CollectiveTrustNetWorthListRoute = routerConfigManager.createRoute<CollectiveTrustRouteParams>({
  path: 'collectiveTrustNetWorthList',
  element: <LazyElement load={() => import('@src/page/high-end-finance/collective-trust/trust-net-worth-list-page')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

// 信托公告页面
export const UploadFileDemoRoute = routerConfigManager.createRoute<TrustAnnouncementRouteParams>({
  path: 'uploadFileDemo',
  element: <LazyElement load={() => import('@src/page/high-end-finance/upload-file-demo/index')} />,
  webviewConfig: {
    statusBarDark: 1,
    tztadjustnever: 1,
    tzthiddentitle: 1,
  },
});

export type FundBuyRouteParams = {
  prodType?: 'SM' | 'ZG';
  prodCode: string;
  err646?: boolean;
  err5210?: boolean;
  err5211?: boolean;
  orderNo?: string;
  userNo?: string;
};
// 基金购买页面
export const FundBuyRoute = routerConfigManager.createRoute<FundBuyRouteParams>({
  path: 'fundBuy',
  element: <LazyElement load={() => import('@src/page/high-end-finance/fund-buy/index')} />,
  webviewConfig: {
    statusBarDark: 1,
    fullscreen: 1,
    tzthiddentitle: 0,
    tztadjustnever: 0,
  },
});

export type FundsBuyResultRouteParams = {
  prodStatus: 'application' | 'subscription';
  prodCode: string;
  prodType: 'SM' | 'ZG';
  fundName?: string;
  amount?: string;
};
// 基金购买结果页面
export const FundsBuyResultRoute = routerConfigManager.createRoute<FundsBuyResultRouteParams>({
  path: 'fundsBuyResult',
  element: <LazyElement load={() => import('@src/page/high-end-finance/funds-buy-result/index')} />,
  webviewConfig: {
    statusBarDark: 1,
    tztadjustnever: 1,
    tzthiddentitle: 1,
  },
});

// 基金购买结果页面
export const uploadIdentityInfoRoute = routerConfigManager.createRoute<SignListRouteParams & { clientName?: string }>({
  path: 'uploadIdentityInfo',
  element: <LazyElement load={() => import('@src/page/high-end-finance/upload-identity-info/index')} />,
  webviewConfig: {
    statusBarDark: 1,
    tztadjustnever: 1,
    tzthiddentitle: 1,
  },
});
export const PerformanceFeeCalculateRoute = routerConfigManager.createRoute({
  path: 'performanceFeeCalculate',
  element: <LazyElement load={() => import('@src/page/performance-fee-calculate')} />,
});
export type RiskProductSignListRouteParams = {
  prodCode: string;
  prodName: string;
  buyMoney: string;
  jyType: string;
  prodcodeType: string;
  prodTa?: string;
  allotno?: string;
  isKhd: string;
};
// 资管协议签署列表
export const RiskProductSignListRoute = routerConfigManager.createRoute<RiskProductSignListRouteParams>({
  path: 'riskProductSignList',
  element: <LazyElement load={() => import('@src/page/risk-product-sign-list/index')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});
// 报价回购活动页
export type RegularRepoActivityRouteParams = {
  prodCode: string;
};
export const RegularRepoActivityRoute = routerConfigManager.createRoute<RegularRepoActivityRouteParams>({
  path: 'regularRepoActivity',
  element: <LazyElement load={() => import('@src/page/regular-repo-activity')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});
// 专属推荐页面
export const ExclusiveRecommendPageRoute = routerConfigManager.createRoute({
  path: 'exclusiveRecommend',
  element: <LazyElement load={() => import('@src/page/fund-index/exclusive-recommend')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});
export const ExclusiveRecommendJumpImageRoute = routerConfigManager.createRoute({
  path: 'exclusiveRecommendJumpImage',
  element: <LazyElement load={() => import('@src/page/fund-index/exclusive-recommend/jump-image')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type TrustAnnouncementRouteParams = {
  fundCode: string;
  fundName: string;
  productTypeName: string;
};

// 信托公告页面
export const TrustAnnouncementRoute = routerConfigManager.createRoute<TrustAnnouncementRouteParams>({
  path: 'trustAnnouncement',
  element: <LazyElement load={() => import('@src/page/high-end-finance/collective-trust/trust-announcement')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});

export type TrustBuyResultRouteParams = {
  prodCode: string;
  prodName: string;
  amount: string;
};
// 信托购买结果页面
export const trustBuyResultRoute = routerConfigManager.createRoute<TrustBuyResultRouteParams>({
  path: 'trustBuyResult',
  element: <LazyElement load={() => import('@src/page/high-end-finance/collective-trust/trust-buy-result/index')} />,
  webviewConfig: {
    statusBarDark: 1,
    tztadjustnever: 1,
    tzthiddentitle: 1,
  },
});
// 关联基金
export type RelateFundListRouteParams = {
  title: string;
  originalStockCode: string;
  agencyCode: string;
};
export const RelateFundListRoute = routerConfigManager.createRoute<RelateFundListRouteParams>({
  path: 'relateFundList',
  element: <LazyElement load={() => import('@src/page/relate-fund-list')} />,
  webviewConfig: {
    statusBarDark: 1,
  },
});
